import React, { useContext } from 'react';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, IconButton, Typography } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import { State, BootstrapTooltip } from '../../../../components';
import AppContext, { isUserView } from '../../../../context/AppContext';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    listText: {
        color: '#4A4A4A',
        textAlign: 'center',
        [theme.breakpoints.up('xs')]: {
            marginBottom: theme.spacing(2),
        },
        [theme.breakpoints.up('sm')]: {
            marginBottom: theme.spacing(0),
        }
    },
    cardBody: {
        padding: theme.spacing(3, 6),
        '&:hover': {
            backgroundColor: '#E0E0E0'
        },
        [theme.breakpoints.only('sm')]: {
            padding: theme.spacing(3),
        },
    },
    cardBodyEmpty: {
        padding: theme.spacing(3, 6),
        textAlign: 'center',
        cursor: 'auto'
    },
    deleteIcon:{
        color: '#db1414'
    },
    editIcon:{
        color: '#4a4a4a'
    },
    gridState: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'row'
    }
}));

const TableDesktop = ({ devices, requestUsers, setDeviceDetailsModal, deleteDevice, openEditDevice }) => {
    const classes = useStyles();

    return (
        <>
            {devices.length > 0 ?
                devices.map((device, index) => (
                    <Card id="cardList" key={index} className={classes.root}
                        onClick={() => {
                            // requestUsers(device.deviceKey);
                            setDeviceDetailsModal({open: true, device: device })
                        }}
                    >
                        <CardContent className={classes.cardBody}>
                            <Grid container
                                direction="row"
                                justify="center"
                                alignItems="center"
                            >
                                <Grid item lg={2} sm={2} xs={8}  className={classes.gridState}>
                                    <State selected={device.status} />
                                </Grid>
                                <Grid item lg={!isUserView()?2:3} sm={!isUserView()?2:3} xs={12} >
                                    <Typography className={classes.listText} >
                                        {device.deviceName}
                                    </Typography >
                                </Grid>
                                <Grid item lg={3} sm={3}>
                                    <Typography className={classes.listText} >
                                        {device.deviceKey}
                                    </Typography >
                                </Grid>
                                <Grid item lg={2} sm={2} xs={12} >
                                    <Typography className={classes.listText} >
                                        {device.lastDeviceInfo.personCount}
                                    </Typography >
                                </Grid>
                                <Grid item lg={2} sm={2}>
                                    <Typography className={classes.listText} >
                                        {device.lastDeviceInfo.faceCount}
                                    </Typography >
                                </Grid>
                               {!isUserView() && <Grid item sm={2} md={1} lg={1} className={classes.gridState}>
                                    <BootstrapTooltip title="Editar" >
                                        <IconButton id="open-edit-device" onClick={e => openEditDevice(e, device)} >
                                            <EditIcon className={classes.editIcon}/>
                                        </IconButton>
                                    </BootstrapTooltip>
                                    <BootstrapTooltip title="Remover" >
                                        <IconButton id="delete-device" onClick={e => deleteDevice(e, device.deviceKey, device.deviceName)} >
                                            <DeleteForeverIcon className={classes.deleteIcon}/>
                                        </IconButton>
                                    </BootstrapTooltip>
                                </Grid>}
                            </Grid>
                        </CardContent>
                    </Card>
                )) :
                <Card id="cardList" className={classes.root}>
                    <CardContent className={classes.cardBodyEmpty}>
                        <Typography className={classes.listText} >
                            Lista Vazia
                        </Typography>
                    </CardContent>
                </Card>
            }
        </>
    );
}
export default TableDesktop